import Test3DPage from '@/pages/3d-test/page';
import AboutPage from '@/pages/about/page';
import { PageHeaterGame } from '@/pages/game_heater/PageHeaterGame';
import { PageLightsGame } from '@/pages/game_lights/PageLightsGame';
import { PageQuizzGame } from '@/pages/game_quizz/PageQuizzGame';
import PageIntro from '@/pages/intro/PageIntro';
import PageOutro from '@/pages/outro/PageOutro';
import PageSplash from '@/pages/splash/PageSplash';
import PageThanks from '@/pages/thanks/PageThanks';
import { Redirect } from './Redirect';
import { RoutePaths } from './RoutePaths';

type Page = {
  name: string;
  path: string;
  element: JSX.Element;
  showInNav: boolean;
  showHeader: boolean;
};

const PageRoutes: { [id: string]: Page } = {
  // Navigation routes
  home: {
    name: 'Home',
    path: RoutePaths.home,
    element: <Redirect to={RoutePaths.splash} />,
    showInNav: false,
    showHeader: true,
  },
  splash: {
    name: 'Splash',
    path: RoutePaths.splash,
    element: <PageSplash />,
    showInNav: false,
    showHeader: false,
  },
  intro: {
    name: 'Intro',
    path: RoutePaths.intro,
    element: <PageIntro />,
    showInNav: true,
    showHeader: false,
  },

  // Game routes - referenced in GamePaths.ts
  game_lights: {
    name: 'Game Lights',
    path: RoutePaths.game_lights,
    element: <PageLightsGame />,
    showInNav: true,
    showHeader: false,
  },
  game_heater: {
    name: 'Game Heater',
    path: RoutePaths.game_heater,
    element: <PageHeaterGame />,
    showInNav: true,
    showHeader: false,
  },
  game_quizz_01: {
    name: 'Game Quizz 01',
    path: RoutePaths.game_quizz_01,
    element: <PageQuizzGame />,
    showInNav: true,
    showHeader: false,
  },
  game_quizz_02: {
    name: 'Game Quizz 02',
    path: RoutePaths.game_quizz_02,
    element: <PageQuizzGame />,
    showInNav: true,
    showHeader: false,
  },

  // End routes
  thanks: {
    name: 'Thanks',
    path: RoutePaths.thanks,
    element: <PageThanks />,
    showInNav: true,
    showHeader: false,
  },
  outro: {
    name: 'Outro',
    path: RoutePaths.outro,
    element: <PageOutro />,
    showInNav: true,
    showHeader: false,
  },

  // Test routes
  Test3D: {
    name: 'Test 3D',
    path: RoutePaths.test3d,
    element: <Test3DPage />,
    showInNav: true,
    showHeader: true,
  },
  About: {
    name: 'About',
    path: RoutePaths.about,
    element: <AboutPage />,
    showInNav: true,
    showHeader: true,
  },
} as const;

// this is a type that is a union of all the values of the PageRoutes object
// export type Page = (typeof PageRoutes)[keyof typeof PageRoutes];

// this exports the typce not the const object
export default PageRoutes;
